<template>
  <div>
    <div style="width: 100%">
      <img style="width: 100%" src="./img/顶部背景.png" alt="" />
    </div>

    <div class="bottomCss">
      <div class="xiangqing">
        <!-- 标题图片 -->
        <div class="imgCss">
          <div>{{ this.data.name }}</div>
          <div class="tupailie">
            <img class="datu" :src="this.datu" alt="" />
            <div class="xtpl">
              <div v-for="(item,index) in this.imgdata" :key="index">
                <img
                  @click="qiehuan(index)"
                  class="xioatu"
                  :src="item.url"
                  alt=""
                />
              </div>
              <!-- <img class="xioatu" :src="this.imgdata[2].url" alt="" />
              <img class="xioatu" :src="this.imgdata[3].url" alt="" /> -->
            </div>
          </div>
        </div>
        <!-- 产品简介 -->
        <div class="jianjie">
          <div
            style="
              margin-top: 42px;
              font-size: 30px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            "
          >
            产品介绍
          </div>
          <div style="display: flex; margin-top: 24px; margin-bottom: 24px">
            <div
              v-for="(item, index) in data.biaioqian"
              :key="index"
              class="biaoqian"
            >
              {{ item.bq }}
            </div>
          </div>
          <div
            style="
              font-size: 20px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 38px;
              margin-bottom: 36px;
            "
          >
            {{ this.data.jieshao }}
          </div>
        </div>
        <!-- 产品优点 -->
        <div class="youdian">
          <div
            style="
              margin-top: 36px;
              font-size: 30px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            "
          >
            产品优点
          </div>
          <div class="ydlb">
            <div class="ydnr" v-for="(item,index) in this.youdianData" :key="index">{{item.yd}}</div>
          </div>
        </div>
        <!-- 关键参数 -->
        <div class="canshu">
          <div
            style="
              margin-top: 36px;
              font-size: 30px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            "
          >
            关键参数
          </div>
          <div class="csimg">
            <img style="width: 100%;" :src=this.canshuData alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      youdianData:[
        {yd:"系统能量密度高"},
        {yd:"系统集成度高"},
        {yd:"智能热管理策略,智能液冷温控,降低系统辅助功耗"},
        {yd:"预安装设计，可整机运输"},
        {yd:"支持拼箱并箱，布局灵活"},
        {yd:"均温性好，系统温差≤3℃"},
        {yd:"交直流系统一体化设计，减少直流电缆及开关，降低初始投资"},
      ],
      data: {
        name: "升压一体机",
        biaioqian: [{ bq: "即插即用" }, { bq: "集成高精度温湿度检测系统" }, { bq: "高等级防护" }],
        jieshao:
          "该产品是将三电平PCS、开关柜和升压变压器进行了优化集成，具有集成度高、单机功率大、内部结构紧凑、占地面积较小、应用简单、安装灵活等优点,可选择10KV/35KV电压等级配置直接接入电网。",
        url: require("@/views/product/img/升压一体机.png"),
      },
      datu:require("@/views/product/img/升压一体机.png"),
      canshuData:require("./img/储能升压⼀体机.png"),
      imgdata: [
        { url: require("@/views/product/img/升压一体机.png") },
        { url: require("@/views/product/img/升压一体机.png") },
        { url: require("@/views/product/img/升压一体机.png") },
      ],

    };
  },
  methods: {
    qiehuan(index) {
      if (index==0) {
        this.datu=this.imgdata[0].url
      }else if (index==1) {
        this.datu=this.imgdata[1].url
      }else if (index==2) {
        this.datu=this.imgdata[2].url
      }
    },
  },
  mounted() {
    console.log(this.$route.query.key, "xxxxxxxxxxx");
    // this.data = this.$route.query.key;
    // this.datu=this.$route.query.key.url
  },
};
</script>

<style scoped>
.bottomCss {
  width: 100%;
  height: 100%;
  background: #f2f5f8;
  display: flex;
  justify-content: center;
}
.xiangqing {
  width: 69%;
  /* height: 3147px; */
  background: #ffffff;
  margin-top: 4%;
  margin-bottom: 4%;
}
.imgCss {
  font-size: 38px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 54px;
}
.datu {
  width: 500px;
  height: 500px;
  margin-bottom: 16px;
  margin-top: 42px;
}
.tupailie {
  display: flex;
  flex-direction: column;
}
.xtpl {
  display: flex;
  justify-content: space-evenly;
}
.xioatu {
  width: 110px;
  height: 110px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 12px 12px;
}
.xioatu:hover {
  width: 110px;
  height: 110px;
  border: 2px solid rgba(9, 64, 253, 1);
  border-radius: 12px 12px 12px 12px;
}
.jianjie {
  margin: 0px 64px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.youdian {
  margin: 0px 64px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.canshu {
  margin: 0px 64px 64px 64px;
}
.biaoqian {
  margin-right: 12px;
  height: 36px;
  background: rgba(9, 64, 253, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  border-radius: 6px 6px 6px 6px;
  color: #0940fd;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
.ydlb {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 36px;
}
.ydnr {
  width: 50%;
  font-size: 20px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  margin-top: 24px;
}
.ydnr::before {
  content: "";
  display: flex;
  width: 9px;
  height: 9px;
  background: #0940fd;
  border-radius: 50%;
  margin-right: 16px;
}
.csimg {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>